import { styled, Dialog, DialogContent, Button } from "@mui/material";

export const DialogRoot = styled(Dialog)(({ theme }) => ({
  zIndex: 200,
  ".MuiDialog-paper": {
    background: "none",
    borderRadius: 0,
    position: "relative",
    boxShadow: "none",
    width: "100%",
    maxWidth: "100dvw",
    height: "100%",
    maxHeight: "100dvh",
    margin: 0,
    padding: 0,
    border: "none",
    color: theme?.palette?.companyColors?.secondary,
  },
}));

export const DialogCustomContent = styled(DialogContent)(({ theme }) => ({
  overflow: "hidden",
  width: "100%",
  padding: 0,
  border: "none",
}));

export const DialogCloseButton = styled(Button)(({ theme }) => ({
  position: "absolute",
  right: "1rem",
  top: "16rem",
  background: "none",
  borderRadius: 0,
  minWidth: 50,
  height: 50,
  padding: 5,
  transition: "all 0.3s ease",
  [theme.breakpoints.up("md")]: {
    minWidth: 40,
    height: 40,
  },
  [theme.breakpoints.up("xl")]: {
    minWidth: 50,
    height: 50,
  },
  "@media only screen and (min-width: 2560px) and (min-height: 1440px)": {
    width: "4rem",
    height: "4rem",
  },
  "&:hover": {
    background: "none",
    transform: "scale(0.85)",
    opacity: "0.9",
  },
  "& img": {
    width: "75%",
  },
}));
